import React from 'react';
import Button from 'reactstrap/lib/Button';
import { FilterButtonProps } from '.';

/**
 * Button for adding a filter.
 */
export default function FiltersListAddButton(props: FilterButtonProps) {
	return (
		<div className="filters-popover__action">
			<Button type="button" color="primary" data-testid="add-filter-btn" onClick={props.onClick}>
				Filter
			</Button>
		</div>
	);
}
